import { MaterialColor } from '@services/colors/interfaces/colors.interfaces';
import { Mock } from '@shared/interfaces/mock.interface';

export const COLORS_DATA: MaterialColor[] = [
  { id: '1', name: 'Negro', primaryHex: '#000000', secondaryHex: null, tertiaryHex: null, colorType: 'mono', isAvailable: true },
  { id: '2', name: 'Blanco', primaryHex: '#ffffff', secondaryHex: null, tertiaryHex: null, colorType: 'mono', isAvailable: true },
  { id: '3', name: 'Rojo', primaryHex: '#ff0000', secondaryHex: null, tertiaryHex: null, colorType: 'mono', isAvailable: true },
  { id: '4', name: 'Azul', primaryHex: '#0000ff', secondaryHex: null, tertiaryHex: null, colorType: 'mono', isAvailable: true },
  { id: '5', name: 'Verde', primaryHex: '#00ff00', secondaryHex: null, tertiaryHex: null, colorType: 'mono', isAvailable: false },
];

export const GET_COLORS_MOCK: Mock = {
  success: [{ response: COLORS_DATA }],
  failures: [{ response: { message: 'Error loading colors' } }],
};

export const CREATE_COLOR_MOCK: Mock = {
  success: [
    {
      response: { id: '6', name: 'Amarillo', primaryHex: '#ffff00', secondaryHex: null, tertiaryHex: null, colorType: 'mono', isAvailable: true },
    },
  ],
  failures: [{ response: { code: 10001, message: 'Invalid color data', statusCode: 400 } }],
};

export const UPDATE_COLOR_MOCK: Mock = {
  success: [
    {
      response: { id: '1', name: 'Negro Mate', primaryHex: '#111111', secondaryHex: null, tertiaryHex: null, colorType: 'mono', isAvailable: true },
    },
  ],
  failures: [{ response: { code: 10002, message: 'Color not found', statusCode: 404 } }],
};

export const DELETE_COLOR_MOCK: Mock = {
  success: [{ response: undefined }],
  failures: [{ response: { code: 10002, message: 'Color not found', statusCode: 404 } }],
};
